<template>
  <div id="g-timeaxis" :style="{width: timeAxisParentWidth}">

    <div
      class="g-timeaxis-empty-space"
      :style="{width: rowLabelWidth, background: themeColors.background}"
    />
    <div
      class="g-timeaxis-days"
    >
      <!-- <div
        v-for="(day, index) in axisDays"
        :key="day.text"
        class="g-timeaxis-day"
        :style="{
          width: day.widthPercentage+'%',
          background: index%2===0 ? themeColors.primary : themeColors.secondary,
          color: themeColors.text
        }"
      > -->
      <div
        v-for="(day, index) in axisDays"
        :key="day.text"
        class="g-timeaxis-day"
        :style="{
          width: (ganttChartProps.scaleName === 'day' ? (((day.widthPercentage / 12) * day.ganttHours.length) +'px') : day.widthPercentage + 'px'),
          background: themeColors.background,
          color: themeColors.text
        }"
      >
        <div class="day_value mb-2 pl-2"> {{day.value}} </div>
        <div :style="{background: themeColors.background, color: themeColors.text}" class="mb-1">
          <div
            v-for="(hour, indexHour) in day.ganttHours"
            :key="indexHour"
            class="g-timeaxis-hour"
          >
          <template>
            <div class="hour_wrapper">
              <p class="hour_title mb-0" v-if="hour.title">{{ hour.title }}</p>
              <span
                :style="{fontSize: hourFontSize}"
                class="hour_week_color"
              >
                {{hour.text}}
              </span>
            </div>
          </template>
            <!-- <div
              class="g-timeaxis-hour-pin"
              :style="{background: themeColors.text}"
            /> -->
          </div>
        </div>
      </div>

    </div>
    <!--<div id="g-timeaxis-marker" class="bg-primary"/>-->

  </div>
</template>
<script>
import moment from 'moment'
// helpers
import eventBus from '@/helpers/event-bus'

export default {

  name:"GGanttTimeaxis",

  props: {
    chartStart: String,
    chartEnd: String,
    rowLabelWidth: String,
    timemarkerOffset: {type: Number, default: 0},
    locale: String,
    themeColors: Object
  },

  inject: ['ganttChartProps'],

  data(){
    return {
      axisDays: [],
      hourCount: null,
      timemarker: null,
      hourFontSize: "12px",
      dayFormat: "dddd, DD. MMMM"
    }
  },

  mounted(){
    //this.timemarker = document.querySelector("#g-timeaxis-marker")
    this.initAxisDaysAndHours()
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize)
  },

  computed: {
    timeAxisParentWidth(){
      let hours = null;
      if(this.axisDays.length) {
          hours = this.axisDays.reduce((accumulator, el) => {
              accumulator += Number(el.ganttHours.length);
              return accumulator
          }, 0)
      }

      let allDays = this.axisDays.reduce((accum, day) => {
          accum = accum + Number(day.ganttHours.length);
          return accum
      }, 0)



      let scale = this.ganttChartProps.scaleName === 'day' ? (this.ganttChartProps.scaleSize / (this.axisDays.length * 12) * (allDays - 1)) : this.ganttChartProps.scaleSize
      let width = `${this.axisDays.length * scale + Number(this.rowLabelWidth.replace('px', ''))}px`
      this.$emit('timeAxisParentWidth', this.axisDays.length * scale + Number(this.rowLabelWidth.replace('px', '')))
      return width
    }
  },

  methods: {
    initAxisDaysAndHours(){
      this.axisDays = []
      let start = moment(this.chartStart)
      let end = moment(this.chartEnd)
      this.hourCount = Math.floor(end.diff(start, "hour", true))
      let endMoment = end.format('HH')
      while(start.isBefore(end)){
        let widthPercentage = this.ganttChartProps.scaleSize
        // let endHour = start.day()===end.day() ? end.hour()-1 : 23   // -1 because the last hour is not included e.g if chartEnd=04:00 the last interval we display is between 03 and 04
        let endHour = null
        let increment = null
        if(this.ganttChartProps.scaleName == 'day'){
          increment = 2
          endHour = Math.abs(Number(start.diff(end, 'd'))) === 0 ? Number(endMoment) : 23
        }else{
          increment = 24
          endHour = this.ganttChartProps.scaleDays * 24 - 24
        }
        this.axisDays.push(this.getAxisDayObject(start, widthPercentage, endHour, increment, end))
        start.add(this.ganttChartProps.scaleDays,"day").hour(0)
      }
    },

    getAxisDayObject(datetime, widthPercentage, endHour, increment, end){
      let datetimeMoment = moment(datetime)
      let axisDayObject = {
        widthPercentage : widthPercentage,
        value : datetime.format("ll"),
        ganttHours : []
      }
      if(this.ganttChartProps.scaleName == 'week'){
        axisDayObject.value = `W${moment(datetime).add(daysIncrement, 'day').week()}`
      }else if(this.ganttChartProps.scaleName == 'month'){
        axisDayObject.value = `${datetime.format("ll")} - ${moment(datetime).add(this.ganttChartProps.scaleDays - 1,"day").hour(0).format("ll")}`
      }

      let startHour = datetimeMoment.hour()
      let daysIncrement = 0
      for(let i=0; i <= (Math.ceil(endHour-startHour)); i+=increment) {
        let hour = {
          title: null,
          text: '',
          fullDatetime: moment(datetime).add(i, 'h').format("DD.MM.YYYY HH:mm")
        }
        if(this.ganttChartProps.scaleName == 'day'){
          hour.text = moment(datetime).add(i, 'h').format("H")
        }else if(this.ganttChartProps.scaleName == 'week'){
          hour.text = `${moment(datetime).add(daysIncrement, 'day').format('DD')}/${moment(datetime).add(daysIncrement, 'day').format('MM')}`
          hour.title = `${moment(datetime).add(daysIncrement, 'day').format('ddd')}`
        }else if(this.ganttChartProps.scaleName == 'month'){
          hour.text = moment(datetime).add(daysIncrement, 'day').date()
        }

        axisDayObject.ganttHours.push(hour)
        daysIncrement += 1
      }
      return axisDayObject
    },

    onWindowResize(){
      let axis = document.querySelector("#g-timeaxis")
      if (axis) this.horizontalAxisContainer = axis.getBoundingClientRect()
      // this.hourFontSize = Math.max(9.5, 0.75*(this.horizontalAxisContainer.width/this.hourCount))+"px"
    },

  },

  watch: {
    'ganttChartProps.scaleSize'(){
      this.initAxisDaysAndHours()
    },
    chartStart(){
      this.initAxisDaysAndHours()
    },
    chartEnd(){
      this.initAxisDaysAndHours()
    }
  }
}
</script>

<style scoped lang="scss">
  #g-timeaxis, .g-timeaxis-days, .g-timeaxis-day, .g-timeaxis-day > div {
    display: flex;
    overflow: hidden;
  }

  #g-timeaxis {
    position: sticky;
    top:0;
    width: 100%;
    /* height: 8%; */
    /* min-height: 75px; */
    background: white;
    z-index: 4;
    border-bottom: 1px solid #f4f5f8;
  }

  #g-timeaxis > .g-timeaxis-empty-space {
    width: 20%;    /* this has to be as wide as .ganttRowTitle in VGanttastic.css */
    height: 100%;
    background: #F5F5F5;
  }

  #g-timeaxis > .g-timeaxis-days {
    position: relative;
    width: auto;
    height: 100%,
  }

  .g-timeaxis-day {
    height: 100%;
    flex-direction: column;
    background: #E0E0E0;
    position: relative;
    &:after,
    &:before{
      content: '';
      position: absolute;
      right: 0;
      height: 100%;
        width: 1px;
        background-color: #f4f5f8;
    }
    &:before{
      left: 0;
    }
  }

  /* .g-timeaxis-day:nth-child(odd) {
    background: #E8E8E8;
  } */

  .g-timeaxis-day > div:nth-child(1) { /* day text */
    justify-content: flex-start;
    font-weight: bold;
    align-items: center;
  }

  .g-timeaxis-day > div:nth-child(2) { /* hours of a day */
    align-items: flex-end;
    justify-content: center;
    /* background:#F5F5F5; */
    padding-top:2px;
    color: #212121;
  }

  .hour_wrapper{
    width: 100%;
    text-align: center;
    line-height: 14px;
  }

  .hour_week_color,
  .day_value{
    color: #2e2e2e;
  }

  .hour_title{
    color: black;
    font-size: 12px;
    line-height: 12px;
  }

  .day_value{
    font-size: 14px;
    font-weight: bold;
  }

  .g-timeaxis-hour {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
  }

  .g-timeaxis-hour-pin {
    width: 1px;
    height: 8px;
  }

  #g-timeaxis-marker {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 1px;
    opacity: 0.7;
  }
</style>

